let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cc7PE")).then(() => parcelRequire('kCX1O'));